document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  const skuElement = document.querySelector('#product-sku');

  if (variant && skuElement) {
    skuElement.textContent = variant.sku || '—';
  }

//     // --- Update Locations ---
//   const locationElement = document.querySelector('#product-locations');
//   if (!locationElement || !variant) return;

//   // Find the hidden variant data
//   const locationNode = document.querySelector(
//     `.variant-location-data[data-variant-id="${variant.id}"]`
//   );

//   if (!locationNode) {
//     locationElement.textContent = '';
//     return;
//   }

});

